// extracted by mini-css-extract-plugin
module.exports = {"navItem":"Header_navItem__tLoAV","dropdown":"Header_dropdown__25Pew"};